(function () {
  function productUrlFrom(swiperEl) {
    var content = swiperEl.closest('.grid-product__content');
    if (!content) return '';
    var link = content.querySelector('a.grid-product__link');
    return link && link.getAttribute('href') ? link.getAttribute('href') : '';
  }

  function bindNav(el) {
    if (!el) return;
    el.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
    });
  }

  function initCollectionSwipers(root) {
    if (typeof Swiper === 'undefined') return;
    var scope = root || document;
    scope.querySelectorAll('.grid-product .swiper:not(.swiper-initialized)').forEach(function (swiperEl) {
      var nextEl = swiperEl.querySelector('.swiper-button-next');
      var prevEl = swiperEl.querySelector('.swiper-button-prev');
      var swiper = new Swiper(swiperEl, {
        loop: false,
        nested: true,
        preventClicks: true,
        preventClicksPropagation: true,
        navigation: {
          nextEl: nextEl,
          prevEl: prevEl,
        },
        autoHeight: true,
      });

      bindNav(nextEl);
      bindNav(prevEl);

      swiperEl.addEventListener('click', function (event) {
        if (event.target.closest('.swiper-button-next, .swiper-button-prev')) return;
        var href = productUrlFrom(swiperEl);
        if (href) window.location.href = href;
      });
    });
  }

  function observeAjaxGrid() {
    var ajax = document.getElementById('CollectionAjaxContent');
    if (!ajax || ajax.dataset.starfireSwiperObserved) return;
    ajax.dataset.starfireSwiperObserved = 'true';
    new MutationObserver(function () {
      initCollectionSwipers(ajax);
    }).observe(ajax, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCollectionSwipers();
    observeAjaxGrid();
  });

  document.addEventListener('shopify:section:load', function (event) {
    initCollectionSwipers(event.target);
    observeAjaxGrid();
  });
})();
